import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import logoAnt from "../Header/img/Ant.png";
import { Avatar as Avt } from "@mui/material";
import axios from "axios";
import { path } from "../../path";
import CreateAdModal from "./CreateAdModal";
import AdComponent from "./AdComponent";

function formatDate(inputDate) {
  const date = new Date(inputDate);

  const options = {
    day: "2-digit",
    month: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

function AdvertiserPanel() {
  const Avatar = React.memo(Avt);
  const [advertiserData, setAdvertiserData] = useState([]);
  const [selectedAdvertiser, setSelectedAdvertiser] = useState(null);
  const [AdModal, setAdModal] = useState({ type: null, ad: null });
  const [DeleteModal, setDeleteModal] = useState(null);

  useEffect(() => {
    fetchAdvertisersData();
  }, []);

  const fetchAdvertisersData = async () => {
    try {
      const response = await axios.get(`${path}/advertisers`);
      if (response?.data?.data) {
        setAdvertiserData(response.data.data);
        console.info("advertiser List", response.data.data);
      }
    } catch (error) {
      console.error("error in getting advertiserData:", error);
    }
  };

  const fetchAdvertiserData = async (advertiserId) => {
    try {
      if (!advertiserId) {
        return;
      }
      const response = await axios.get(`${path}/advertiser/${advertiserId}`);
      if (response?.data?.data) {
        setSelectedAdvertiser(response.data.data);
        console.info("specific advertiser:", response?.data?.data);
      }
    } catch (error) {
      console.error("error in getting advertiser:", error);
    }
  };

  const deleteAd = async () => {
    try {
      const response = await axios.delete(`${path}/advertisement/${DeleteModal.id}`);
      if (response.status === 200) {
        setDeleteModal(null);
        fetchAdvertiserData(selectedAdvertiser?._id);
      }
    } catch (error) {
      console.log("error in deleting ad", error);
    }
  };

  const deleteAdvertiser = async() =>{
    try{
      const response = await axios.delete(`${path}/advertiser/${selectedAdvertiser._id}`)
      if(response.status === 200){
        setSelectedAdvertiser(null);
        fetchAdvertisersData();
        setDeleteModal(null);
      }
    }catch(error){
      console.error("error while deleting advertiser profile:",error)
    }
  }

  return (
    <section className="bg-white w-full h-screen p-2">
      {/* Create Ad Modal */}
      {AdModal.type && (
        <CreateAdModal
          AdModal={AdModal}
          setAdModal={setAdModal}
          selectedAdvertiser={selectedAdvertiser}
          fetchAdvertiserData={fetchAdvertiserData}
        />
      )}

      {/* Delete Ad Modal */}
      {DeleteModal && DeleteModal?.type && (
        <div className=" fixed w-full h-screen bg-black/40 flex items-center justify-center inset-0 z-20">
          <div className="bg-white p-4 rounded-lg flex flex-col gap-4">
            <p>Do you want to delete {DeleteModal.type} ? </p>
            <div className=" flex items-center gap-4">
              <button
                className=" px-6 py-2 bg-gray-100 border border-gray-300 rounded-lg"
                onClick={() => setDeleteModal(null)}>
                Cancel
              </button>
              <button
                className="px-8 py-2 text-white bg-red-500 rounded-lg"
                onClick={() => DeleteModal.type === "advertisment"? deleteAd():deleteAdvertiser()}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="flex items-center space-x-20 px-2 py-2">
        <Link to={"/marketingAdmin"} className="">
          <div className="flex items-center">
            <img
              src="https://w7.pngwing.com/pngs/848/762/png-transparent-computer-icons-home-house-home-angle-building-rectangle-thumbnail.png"
              className="h-6 mr-3"
              alt="home"
            />
            <h1>Home</h1>
          </div>
        </Link>
      </div>
      <p className="text-2xl mb-4 text-center self-center ml-16">
        Advertisers List
      </p>

      {/* Create Advertiser Button */}
      <div className="flex space-x-4 mb-4">
        <Link to={"/advertisers/createNew"}>
          <div className="px-4 py-2 bg-yellow-400 border border-yellow-600 rounded-md text-white">
            Create
          </div>
        </Link>
      </div>

      {/* Advertiser List Section */}
      <div className="flex items-start w-full justify-between m-auto">
        {/* Advertiser Lists  */}
        <div
          className={` ${selectedAdvertiser ? "w-4/12 " : "w-11/12"} flex flex-col justify-center items-center p-2`}>
          {/* Box list  */}
          <div className="flex w-full bg-[#008080] justify-between text-white items-center border rounded-lg mx-5 p-2 cursor-pointer px-2">
            <div className="flex space-x-2 items-center   w-5/12 ">
              <h3>Display Name</h3>
            </div>

            {!selectedAdvertiser && (
              <>
                <div className="w-3/12  ">
                  <h3>Email</h3>
                </div>

                <div className="w-2/12 ">
                  <h3>Phone Number</h3>
                </div>

                <div className="w-2/12 ">
                  <h3>Decription</h3>
                </div>
              </>
            )}
          </div>

          {advertiserData?.length ? (
            advertiserData?.map((item) => (
              <div
                key={item?._id}
                onClick={() => fetchAdvertiserData(item?._id)}
                className={`flex w-full  justify-between items-center border my-2 rounded-lg mx-5 p-2 cursor-pointer px-2 overflow-y-s`}>
                <div className="flex space-x-2 items-center   w-5/12">
                  {/* index
                    <h3>{(currentPage - 1) * 3 + i + 1}</h3> */}

                  <div className=" rounded-full overflow-hidden   bg-purple-600 ">
                    {item?.displayPicture ? (
                      <Avatar
                        src={item?.displayPicture}
                        sx={{
                          width: 30,
                          height: 30,
                        }}
                      />
                    ) : (
                      <Avatar
                        src={logoAnt}
                        sx={{
                          width: 30,
                          height: 30,
                        }}
                      />
                    )}
                  </div>

                  <h3>{item?.displayName}</h3>
                </div>

                {!selectedAdvertiser && (
                  <>
                    <div className=" w-3/12 ">
                      <h3>{item?.email}</h3>
                    </div>

                    <div className="w-2/12 ">
                      <h3>{item?.phoneNumber}</h3>
                    </div>

                    <div className="w-2/12 ">
                      <h3>{item?.description}</h3>
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <div>No list</div>
          )}
        </div>

        {/* Selected Advertizer Section */}
        {selectedAdvertiser && (
          <div className="w-8/12  p-2 h-[580px] overflow-hidden overflow-y-scroll bg-gray-100 rounded-lg">
            <div className="flex items-center justify-between  mx-2">
              <div></div>
              <h1 className="text-xl my-2 font-gilroy-bold text-center self-center">
                Details of Advertiser
              </h1>

              <h1
                className="text-lg my-2  cursor-pointer"
                onClick={() => setSelectedAdvertiser(null)}>
                X
              </h1>
            </div>

            {/* Create Ad Button */}
            <div className=" flex justify-end w-full gap-4">
                  <button
                    onClick={() => setAdModal({ type: "createAd", ad: null })}
                    className=" px-6 py-2 bg-green-500 text-white font-semibold rounded-xl ">
                    {" "}
                    + Create Ad
                  </button>
                  <button className=" px-6 py-2 bg-red-500 text-white font-semibold rounded-xl" onClick={()=>setDeleteModal({type:"advertiser",id:selectedAdvertiser._id})}>
                    Delete
                  </button>
                  <Link to={`/advertisers/edit/${selectedAdvertiser._id}`}>
                    <div className="px-4 py-2 bg-blue-500 rounded-md text-white">
                      Edit
                    </div>
                  </Link>
            </div>

            {/* Advertiser Details Section */}
            <div className="flex  p-2">
              <div className="w-8/12  ">
                {[
                  {
                    label: "Email",
                    value: selectedAdvertiser?.email,
                  },
                  {
                    label: "UserId",
                    value: selectedAdvertiser?.userId,
                  },
                  { label: "Name", value: selectedAdvertiser?.displayName },
                  {
                    label: "Phone-Number",
                    value: selectedAdvertiser?.phoneNumber,
                  },
                  {
                    label: "Description",
                    value: selectedAdvertiser?.description,
                  },
                  {
                    label: "Created At",
                    value: formatDate(selectedAdvertiser?.createdAt),
                  },
                ].map(({ label, value }) => (
                  <div key={label} className="flex space-x-2 p-2">
                    <h1 className="font-gilroy-semibold text-gray-500">
                      {label}:
                    </h1>
                    <h1 className="font-gilroy-semibold">{value || "N/A"}</h1>
                  </div>
                ))}
              </div>
              <div className="w-4/12  p-2 flex justify-center items-center">
                {selectedAdvertiser?.displayPicture ? (
                  <Avatar
                    src={selectedAdvertiser?.displayPicture}
                    sx={{
                      width: 200,
                      height: 200,
                    }}
                  />
                ) : (
                  <Avatar
                    src={logoAnt}
                    sx={{
                      width: 200,
                      height: 200,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Ads Section */}
            {selectedAdvertiser?.ads?.length > 0 && (
              <div className="my-3 w-full flex flex-wrap items-start gap-4 p-2">
                {selectedAdvertiser?.ads?.map((ad) => (
                  <AdComponent
                    key={ad?._id}
                    data={ad}
                    setAdModal={setAdModal}
                    setDeleteModal={setDeleteModal}
                  />
                ))}
              </div>
            )}

            
          </div>
        )}
      </div>
    </section>
  );
}

export default AdvertiserPanel;
